<template>
<div class="step-con">
  <div class="infor-headerBg">
    <div class="infor-header layout">
      <a href="#" class="logo"></a>
      <div class="ltxt">医学教育网在线模拟考试系统</div>
    </div>
  </div>
  <div class="rulemain layout clearfix">
    <div class="ruleBox">
      <div class="conBox clearfix">
        <div class="conBox-tit">考生承诺</div>
        <div class="conBox-txt">我是报考参加计算机化考试的考生，我已阅读并知悉了《考试规则》、《<em class="examName"></em>考试违纪违规处理规定》等<em class="examName"></em>考试相关文件和规定。经认真考虑，郑重承诺以下事项：</div>
        <div class="conBox-txt">1.自觉服从考试组织管理部门的统一安排，接受监考人员的检查、监督和管理。</div>
        <div class="conBox-txt">2.保证在考试过程中遵纪守法、诚实守信。</div>
        <div class="conBox-txt">如违反上述承诺，自愿按相关规定接受处罚，并愿意承担由此引起的一切后果。</div>
      </div>
      <div class="confirm">
        <div class="label" :class="{'on':isChecked}" @click="isChecked=!isChecked">我已经仔细阅读以上承诺并确认同意</div>
      </div>
      <a href="javascript:void(0)" @click="toExamCenter" class="bbtn big">同意并开始考试</a>
    </div>
  </div>
  <CommonFooter />
</div>
</template>

<script>
import {CommonFooter} from "../../components/common";

export default {
  name: "step1",
  components:{
    CommonFooter
  },
  data(){
    return{
      isChecked:false
    }
  },
  methods:{
    toExamCenter(){
      const { courseID,centerID,siteCourseID,saveBizID } = this.$route.query
      if(!this.isChecked){
        alert('请先确认同意承诺！')
      }else{
        window.open(`//member.med66.com/qzs/index.html#/turnPageExam?saveBizID=${saveBizID}&courseID=${courseID}&simpleBizKey=trueSimulation&siteCourseID=${siteCourseID}&centerID=${centerID}&referFlag=0&canJumpQuesType=1`,'_blank')
      }
    }
  }
}
</script>

<style scoped>

</style>
